import { useState } from "react"
import { Navigate } from "react-router-dom"
import { useTranslation } from "@/i18n"
import { useAuth } from "@/state/AuthContext"
import { npubOf } from "@/utils/nip19"
import { EmptyState } from "@/components/Feedback"
import { LoginDialog } from "@/components/LoginDialog"

/** `/profile` — redirects to the signed-in user's profile, or offers login. */
export function MyProfilePage() {
  const { t } = useTranslation()
  const { pubkey } = useAuth()
  const [loginOpen, setLoginOpen] = useState(false)

  if (pubkey) return <Navigate to={`/u/${npubOf(pubkey)}`} replace />

  return (
    <div className="page">
      <EmptyState
        icon="user"
        title={t("Your profile")}
        description={t(
          "Log in to see your profile, your follows, your relay list and your notes across the relays you read.",
        )}
        action={
          <button type="button" className="btn btn-primary" onClick={() => setLoginOpen(true)}>
            {t("Log in")}
          </button>
        }
      />
      <LoginDialog open={loginOpen} onClose={() => setLoginOpen(false)} />
    </div>
  )
}
